import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class AppRouterService {

  constructor(private route: Router, private activeRoute: ActivatedRoute) { }
  //参数传递相关
  private params = null;
  public goto(url: Array<any>, params = null) {
    this.params = params;
    this.route.navigate(url);
  }

  //获取所有参数
  public getParams<T>() {
    if (this.params != null)
      return this.params as T;
    else
      return this.activeRoute.snapshot.queryParams as T;
  }

  //获取一个参数
  public getParamByKey<T>(key: string) {
    if (this.params != null && this.params.hasOwnProperty(key))
      return this.params[key];
    if (this.activeRoute.snapshot.queryParamMap != null
      && this.activeRoute.snapshot.queryParamMap.has(key))
      return this.activeRoute.snapshot.queryParamMap.get(key);
    return null;
  }
}
